import styled from '@emotion/styled'
import { Container, Grid } from '@mui/material'
import React from 'react'
import { Text } from '../../../../Components/Text'
import pulseRewards from '../../../../images/pulse-rewards.png'
import autoRewards from '../../../../images/auto-rewards.png'
import antiDumpLock from '../../../../images/anti-dump-lock.png'
import tokenBurn from '../../../../images/token-burn.png'
import automaticLP from '../../../../images/automatic-lp.png'
import community from '../../../../images/community.png'
import { FeaturesCard } from './Cards'
import { Heading } from '../../../../Components/Heading'

export const Features = () => {
  return (
    <Container id="features" maxWidth="xl">
        <Grid container>
            <Grid item xs={12}>
                <Heading mb="0px">FEATURES</Heading>
                <Text mb="10px" maxWidth="650px">Below are some of the features that make $PRINT worthy of your attention!</Text>
            </Grid>
            <FeaturesCard 
                cardIcon={pulseRewards}
                cardHeading="$PRINT Rewards"
                discription="6% of all transactions are redistributed in $PRINT to all the holders of $PRINT. The process is done automatically and the holders can get full-fledged details via the dashboard."
            />
            <FeaturesCard 
                cardIcon={autoRewards}
                cardHeading="Auto-rewards"
                discription="With the addition of the Auto-rewards mechanism, you wouldn't have to manually claim the rewards as they would automatically be stored in your wallet on regular basis."
            />
            <FeaturesCard 
                cardIcon={antiDumpLock}
                cardHeading="Anti-dump Lock"
                discription="Worried about whales selling significant sums of tokens in a single transaction? Then worry no more as the Anti-dump lock prohibits the whales from selling no more than 0.1% of their total supply. "
            />
            <FeaturesCard 
                cardIcon={tokenBurn}
                cardHeading="Token Burn"
                discription="To make the token hyper-deflationary, 2% of each transaction will be permanently burned for the buyback of $PRINT."
            />
            <FeaturesCard 
                cardIcon={automaticLP}
                cardHeading="Automatic LP"
                discription="In order to make $PRINT sustainable and stable for the future, 2% of every transaction will be used for the liquidity pool contribution."
            />
            <FeaturesCard 
                cardIcon={community}
                cardHeading="For the Community"
                discription="Our ambition is to serve the community through a revolutionary PulseChain-based project!"
            />
        </Grid>
    </Container>
  )
}
